module.exports = __webpack_public_path__ + "assets/bold.045d7e19.svg";